module.exports = ".row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    /* margin-bottom: -10px; */\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/demand-survey/demandsurvey-form/demandsurvey-form.component.css
// module id = ./src/app/landprocurement/demand-survey/demandsurvey-form/demandsurvey-form.component.css
// module chunks = main